module.exports = __webpack_public_path__ + "img/S_C_H_A_U_K_E_L_N.01ef8f18.jpg";